import { Outlet } from "react-router";
import Sidebar from "../sidebar";
import { Box } from "@mui/material";
import useAuth from "../../hooks/useAuth";
import useSubscriptionMonitor from "../../hooks/useSubscriptionMonitor";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AccountSagaActions } from "../../store/account/sagas";
import { PaymentSagaActions } from "../../store/payment/sagas";
import useConfig from "../../hooks/useConfig";
import { useTheme } from "styled-components";
import { MainLayoutWrapper } from "../../pageComponents/auth/style";
import { MetaDataSagaActions } from "../../store/metadata/sagas";
import LogoLoader from "../commonComponents/LogoLoader";

const MainLayout = () => {
  const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const theme = useTheme();
  const { drawerOpen } = useConfig();

  // Add subscription monitoring for authenticated users
  useSubscriptionMonitor();

  useEffect(() => {
    if (isAuthenticated) {
      setLoading(true);

      setTimeout(() => setLoading(false), 1500);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      const userDetails = JSON.parse(localStorage.getItem("User") as string);

      dispatch(AccountSagaActions.fetchUserDetails(userDetails?._id));
      dispatch(PaymentSagaActions.fetchActiveSubscription(userDetails?._id));
    }
  }, [isAuthenticated, window.location.pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(MetaDataSagaActions.checkNotification());
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  if (loading) return <LogoLoader />;

  return (
    <Box
      sx={{
        display: "flex",
        height: "100dvh",
      }}
    >
      {isAuthenticated && <Sidebar />}
      <MainLayoutWrapper drawerOpen={drawerOpen} id="content">
        <Outlet />
      </MainLayoutWrapper>
    </Box>
  );
};

export default MainLayout;
